<!-- eslint-disable max-len -->
<template lang="pug">
web-app-layout(:showLogo="true")
  div
    div
      .img-uploader.pos-r.mb-4
        template(v-if="item.url")
          img(:src="item.url").img-fluid.el-upload
    div.py-2
      h6.mb-0.sticker-tag-text(v-if="item.campaignType") {{ item.campaignType }}
    div(v-if="item.organization == null")
      .row.row-xs.align-items-center.py-2
        .col-auto
          img(:src="item.user.avatar"
            v-if="item.user.avatar").d-block.size-18.obj-f-c.rounded-circle
          img(src="@/assets/images/default-profile.jpeg"
            v-if="!item.user.avatar").d-block.size-18.obj-f-c.rounded-circle
        .col.lh-1 {{ item.user.firstname }} {{ item.user.lastname }}
    div(v-if="item.organization != null")
      .row.row-xs.align-items-center.py-2
        .col-auto
          img(:src="item.organization.avatar"
            v-if="item.organization.avatar").d-block.size-18.obj-f-c.rounded-circle
          img(src="@/assets/images/default-profile.jpeg"
            v-if="!item.organization.avatar").d-block.size-18.obj-f-c.rounded-circle
        .col.lh-1 {{ item.organization.name }}
    div
      h2.mb-0.py-2 {{ item.title }}
    div
      .fs-14.sticker-price-color-text
        span
          span(v-if="item.cost == 0") FREE
          span(v-else) ${{ item.cost.toFixed(2) }}
    div(v-if="item.eventDate").row
      .col-6
        h5.mb-0.py-2 {{ getformattedDate(item.eventDate) }}
        .fs-18.lh-2 Date
      .col-6
        h5.mb-0.py-2 {{ getformattedTime(item.eventDate) }}
        .fs-18.lh-2 Time
    
    //- Glow Badge
    div(v-if="item.glow").py-3
      .glow-badge-public
        .glow-badge-icon ⚡
        .glow-badge-content
          .glow-badge-title {{ item.glow.title || 'GLOW EVENT' }}
          .glow-badge-date(v-if="item.glow.glowStartDate && item.glow.glowEndDate") {{ getformattedDate(item.glow.glowStartDate) }} - {{ getformattedDate(item.glow.glowEndDate) }}
          .glow-badge-description(v-if="item.glow.description") {{ item.glow.description }}
    
    div.py-4(v-if="item.campaignType && item.campaignType === 'Ticket'")
      el-button(
        type='success' round
        @click='onStickerActionButtonClick'
        v-loading='loading'
      ).w-80.mb-2.width-80-percent
        span
          span(v-if="item.cost == 0 || isStickerPurchased === true") Add Sticker To Your Profile
          span(v-else-if="item.campaignType && item.campaignType === 'Ticket'") RSVP
          span(v-else-if="item.campaignType && item.campaignType === 'Campaign'") Donate
          span(v-else) Purchase

      el-button(
        type='success' round
        @click='addToCalendarClick(item.eventDate, item.description, item.location, item.title)'
        v-loading='loading'
      ).mb-2.add-calendar-btn
        fai(type="fal" icon="calendar-plus").size-24
    div.py-4(v-else)
      el-button(type='success' round
          @click='onStickerActionButtonClick' v-loading='loading').w-100.mb-2
            span
              span(v-if="item.cost == 0 || isStickerPurchased === true") Add Sticker To Your Profile
              span(v-else-if="item.campaignType && item.campaignType === 'Campaign'") Donate
              span(v-else) Purchase

    div(v-if="item.location")
      h6.mb-0.py-2 Location
      .fs-18.lh-2 {{ item.location }}

    div
      h6.mb-0.py-2 Details
      .fs-18.lh-2 {{ item.description }}

    div(v-if="item.waiverURL && item.waiverURL.indexOf('http')>=0")
      h6.mb-0.py-2 Waiver
      iframe(
        :src="item.waiverURL"
        :title="item.waiverURL"
        width="100%"
        height="250px"
      )
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import WebAppLayout from '../dashboard/WebAppLayout.vue';
import gqlRequest from '../dashboard/gql-request';
import VueMultiselect from 'vue-multiselect';
import SmartBanner from './SmartBanner.vue';
import { collectFreeSticker, collectAnonymousFreeSticker } from '@/graphs/stickers';
import { makeRequest } from '@/graphs/index';
import { mask } from 'vue-the-mask';
import isUUID from '@/utils/isUUID';
import { addToCalendarClick } from '@/utils/calendarUtils.ts';

dayjs.extend(utc);

export default defineComponent({
  name: 'WebAppSticker',
  components: { WebAppLayout },
  setup() {
    const {
      route, router, getPublicSticker,
    } = gqlRequest();

    const { stickerId } = route.params;
    const firstCauseName = ref('');
    const store = useStore();
    const isPromptDownloadApp = ref(false);
    const isStickerPurchased = ref(false);
    const loading = ref(false);

    const item = reactive({
      id: null,
      title: '',
      description: '',
      url: '',
      published: false,
      tags: ref([]),
      cost: 0,
      campaignType: null,
      causes: ref(['']),
      // nonProfitSuggestions: ref([]),
      maxQuantity: 0,
      maxDonation: null,
      donationMultiplier: 1,
      impact: null,
      startDate: null,
      endDate: null,
      user: { firstname: '', lastname: '', avatar: null },
      organization: { name: '', avatar: null },
      creatorTitle: null,
      isFeatured: false,
      isCausesSearchAllowed: false,
      glow: null,
    });

    function checkAuth() {
      if (store.getters['users/isMeSignedIn']) {
        if (route.path !== `/web/sticker/${stickerId}`) {
          router.push(`/web/sticker/${stickerId}`);
        }
      }
    }

    function getCausesList() {
      let firstCause = '';
      console.log('causes are ', item.causes);
      if (item.causes.length) {
        // eslint-disable-next-line prefer-destructuring
        // eslint-disable-next-line prefer-destructuring
        // firstCauseName.value = `Cause: ${firstCause.split(' : ')[0]}`;
        // firstCauseName.value = item.causes.map((x) => x.split(' : ')[0]);
        // eslint-disable-next-line array-callback-return
        item.causes.map((x, index) => {
          if (index === 0) {
            firstCause = `${firstCause} ${x.split(' : ')[0]}`;
          } else { firstCause = `${firstCause}, ${x.split(' : ')[0]}`; }
        });
        console.log('firstCause', firstCause);
      }
      return firstCause;
    }

    async function getItem() {
      const sticker = await getPublicSticker(stickerId);
      Object.assign(item, sticker);
      item.causes = (sticker.causes !== null && sticker.causes !== '') ? sticker.causes.split(' |=| ') : [];
      getCausesList();
      // item.tags = (item.tags !== null && item.tags !== '') ? item.tags.split(' |=| ') : [];
      // [item.postDate, item.postTime] = dateAndTime(itm.createdAt);
      // // eslint-disable-next-line prefer-destructuring
      // item.startDate = new Date(item.startDate).toISOString().split('T')[0];
      // // eslint-disable-next-line prefer-destructuring
      // item.endDate = new Date(item.endDate).toISOString().split('T')[0];
    }

    function getformattedDate(timeOffset: string|number|Date) {
      const t = dayjs(timeOffset);
      return `${t.format('MM/dd/yy')}`;
    }

    function getformattedTime(timeOffset: string|number|Date) {
      const t = dayjs(timeOffset);
      return `${t.format('hh:mm a')}`;
    }

    async function onStickerActionButtonClick() {
      loading.value = true;
      try {
        router.push(`/auth/web/signup?stickerId=${stickerId}`);
      } catch (err) {
        console.error('Error navigating to signup:', err);
        loading.value = false;
      }
    }

    onMounted(async () => {
      loading.value = true;
      await checkAuth();
      await getItem();
      store.commit('shared/SET_MAIN_MENU_COLLAPSE', false);
      loading.value = false;
    });

    return {
      route,
      router,
      loading,
      // data
      item,
      getCausesList,
      firstCauseName,
      onStickerActionButtonClick,
      isPromptDownloadApp,
      isStickerPurchased,
      getformattedDate,
      getformattedTime,
      addToCalendarClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.sticker-tag-text {
  background-color: #1fbeaf;
  color: white;
  border-radius: 3px !important;
  padding: 4px 8px;
  width: fit-content;
  text-transform: uppercase !important;
}
.sticker-price-color-text {
  color: #005c6b !important;
}

.glow-badge-public {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  color: #1a1a1a;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 10px 40px rgba(251, 191, 36, 0.4);
  animation: glow-pulse 2s ease-in-out infinite;
  
  .glow-badge-icon {
    font-size: 24px;
    flex-shrink: 0;
  }
  
  .glow-badge-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }
  
  .glow-badge-title {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  .glow-badge-date {
    font-size: 14px;
    font-weight: 600;
  }
  
  .glow-badge-description {
    font-size: 13px;
    margin-top: 4px;
    line-height: 1.4;
  }
}

@keyframes glow-pulse {
  0%, 100% {
    box-shadow: 0 10px 40px rgba(251, 191, 36, 0.4);
  }
  50% {
    box-shadow: 0 10px 60px rgba(251, 191, 36, 0.6);
  }
}
</style>
